import { createScoreboardHudController } from './scoreboardHudController.js';
import { buildMatchScoreboard } from '../../application/matchScoreboard.js';
import { SCOREBOARD_SORT_KEYS } from '../../domain/scoreboardModel.js';
import {
  loadClientSettingsSnapshot,
  mergeClientSettingsSnapshot
} from '../settings/persistClientSettings.js';

/**
 * wireScoreboardHud — TAB hold + `__debugScoreboard` for agent smoke (SPY-41 / FID-HUD-03).
 */
export function wireScoreboardHud({
  documentRef = globalThis.document,
  matchRuntime,
  globalObj = typeof window !== 'undefined' ? window : undefined,
  storage = typeof globalThis.localStorage !== 'undefined'
    ? globalThis.localStorage
    : null
} = {}) {
  const rootEl = documentRef?.getElementById?.('scoreboard-modal') || null;
  const tbodyEl = documentRef?.getElementById?.('scoreboard-tbody') || null;
  const initial = loadClientSettingsSnapshot(storage) || {};
  let sortKey = SCOREBOARD_SORT_KEYS.includes(initial.scoreboardSort)
    ? initial.scoreboardSort
    : 'team';

  const hud = createScoreboardHudController({
    rootEl,
    tbodyEl,
    getRows: () => buildMatchScoreboard(matchRuntime, sortKey)
  });

  function setSort(next) {
    if (!SCOREBOARD_SORT_KEYS.includes(next)) return sortKey;
    sortKey = next;
    mergeClientSettingsSnapshot(storage, { scoreboardSort: sortKey });
    if (hud.isVisible()) hud.render();
    return sortKey;
  }

  if (globalObj) {
    globalObj.__debugScoreboard = {
      show: () => hud.show(),
      hide: () => hud.hide(),
      toggle: () => hud.toggle(),
      get: () => hud.getSnapshot(),
      isVisible: () => hud.isVisible(),
      getSort: () => sortKey,
      setSort,
      listSortKeys: () => [...SCOREBOARD_SORT_KEYS]
    };
  }

  return {
    onOpenScoreboard: () => hud.show(),
    onCloseScoreboard: () => hud.hide(),
    hud,
    debugApi: globalObj?.__debugScoreboard || null
  };
}
